import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import DocumentTitle from 'react-document-title';
import OutsideClickHandler from 'react-outside-click-handler';
import React, { useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import './WithNavigation.scss';
import { fetchAuthenticatedUser } from 'src/store/actions/auth';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import Button from '../../components/Button';
import FontAwesomeIcon from '../../components/Icon';
import Sidebar from './Sidebar';
import Loader from '../../components/Loader';
import { setSideBar } from 'src/store/actions/collapseSideBar';
import { selectCollapseSideBar } from 'src/store/selectors/collapseSideBar';
import { Images } from 'src/Tenants';

interface WithNavigationProps {
  bottom?: any;
  title?: any;
  top?: any;
  border?: any;
  hide?: any;
  children?: any;
  id?: any;
  testId?: any;
}

const WithNavigation = ({
  bottom,
  title,
  top,
  border,
  hide,
  children,
  id,
  testId,
}: WithNavigationProps) => {
  const [sidebarIsVisible, setSidebarIsVisible] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector(selectAuthenticatedUser);
  const collapsableSideBar = useSelector(selectCollapseSideBar);

  useEffect(() => {
    dispatch(fetchAuthenticatedUser() as any);
  }, []);

  const collapsableSideBarHandler = () => {
    dispatch(setSideBar(!collapsableSideBar) as any);
  };

  const theme = localStorage.getItem('theme');
  const content = children ?? bottom;

  return user ? (
    <DocumentTitle
      title={theme === 'Shape' ? `SHAPE | ${title} ` : `${title} | juniper`}
    >
      <>
        <Div100vh className="with-navigation">
          <OutsideClickHandler
            onOutsideClick={() => {
              setSidebarIsVisible(false);
            }}
          >
            <div
              className={classNames('with-navigation__aside', {
                'with-navigation__aside--visible': sidebarIsVisible,
                'with-navigation__aside--collapseWidth': collapsableSideBar,
              })}
            >
              <Sidebar
                user={user}
                collapsableSideBar={() => collapsableSideBarHandler()}
                collapseSideBar={collapsableSideBar}
              />
            </div>
          </OutsideClickHandler>
          <div
            className={classNames('with-navigation__blinds', {
              'with-navigation__blinds--visible': sidebarIsVisible,
            })}
          />
          <div
            className={classNames('with-navigation__body', {
              'with-navigation__body--collapseSideBar': collapsableSideBar,
            })}
          >
            <div className="with-navigation__hamburger-bar">
              <div className="with-navigation__hamburger">
                <Button
                  onClick={() => setSidebarIsVisible(!sidebarIsVisible)}
                  weight="semantic"
                  icon={<FontAwesomeIcon weight="light" glyph="bars" />}
                />
              </div>
              <div className="with-navigation__logo">
                <img
                  alt="juniper"
                  src={Images.logo}
                  style={{
                    height:
                      theme === 'Formwerks'
                        ? 'auto'
                        : theme === 'Quadra' || theme === 'Panatch'
                          ? '4rem'
                          : '2.5rem',
                  }}
                />
              </div>
            </div>
            <div className="with-navigation__yield" data-cy={testId} id={id}>
              {top && (
                <div
                  className="with-navigation__top"
                  style={{ borderBottomWidth: border ? 0 : null }}
                >
                  {top}
                </div>
              )}
              <div
                className="with-navigation__bottom"
                style={{ display: hide === true && 'none' }}
              >
                <div className="with-navigation__content">{content}</div>
              </div>
            </div>
          </div>
        </Div100vh>
      </>
    </DocumentTitle>
  ) : (
    <Loader />
  );
};

export default WithNavigation;